import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/layout/app-shell';
import { useAuth } from '@/lib/auth';
import { TurmaFilterProvider } from '@/lib/turma-filter';
import { AlunosPage } from '@/pages/alunos-page';
import { LoginPage } from '@/pages/login-page';
import { PainelPage } from '@/pages/painel-page';
import { PresencaPage } from '@/pages/presenca-page';
import { ProfessoresPage } from '@/pages/professores-page';
import { TurmasPage } from '@/pages/turmas-page';

function ProtectedLayout() {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return (
    <TurmaFilterProvider>
      <AppShell />
    </TurmaFilterProvider>
  );
}

function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/alunos" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedLayout />}>
        <Route index element={<Navigate to="/alunos" replace />} />
        <Route path="/alunos" element={<AlunosPage />} />
        <Route path="/turmas" element={<TurmasPage />} />
        <Route path="/presenca" element={<PresencaPage />} />
        <Route path="/painel" element={<PainelPage />} />
        <Route
          path="/professores"
          element={
            <AdminRoute>
              <ProfessoresPage />
            </AdminRoute>
          }
        />
        <Route path="*" element={<Navigate to="/alunos" replace />} />
      </Route>
    </Routes>
  );
}
